/**
 * src/components/analytics/GoogleAnalytics.jsx
 *
 * Google Analytics 4 (GA4). El gtag.js de Google, configurado con privacy-
 * friendly defaults: IP anonymization, no allow_google_signals (cross-site
 * tracking), no allow_ad_personalization_signals.
 *
 * Activación: setear NEXT_PUBLIC_GA4_MEASUREMENT_ID en Vercel
 * (formato G-XXXXXXXXXX).
 *
 * Consent gate: respeta el opt-in de marketing del CookieConsentBanner.
 * Cuando user acepta, GA empieza a trackear. Cuando rechaza, no carga el
 * script (no se envían eventos a Google).
 *
 * Conversiones server-side: GA4 también soporta Measurement Protocol para
 * eventos server-side (purchase, subscribe, etc.). Por ahora confiamos en
 * el cliente; si vemos discrepancias grandes con Meta/TikTok CAPI, sumamos
 * Measurement Protocol en una iteración futura.
 *
 * Verificación: abrir GA4 → Reports → Realtime. Debería aparecer 1+ user
 * activo cuando entrás a drvictorlegal.com con marketing consent dado.
 */

'use client';

import Script from 'next/script';
import { useMarketingConsent } from '@/lib/cookie-consent';

export default function GoogleAnalytics() {
  const measurementId = process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID;
  const consentGranted = useMarketingConsent();

  if (!measurementId) return null;
  if (!consentGranted) return null;

  return (
    <>
      {/* PERF (auditoría PageSpeed 2026-07-03): lazyOnload — ver MetaPixel.jsx. */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
        strategy="lazyOnload"
      />
      <Script id="ga4-init" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}', {
            anonymize_ip: true,
            allow_google_signals: false,
            allow_ad_personalization_signals: false,
          });
        `}
      </Script>
    </>
  );
}
